import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  width: 100%;\n  display: flex;\n  justify-content: end;\n  button {\n    font-size: 16px;\n    padding: 12px 20px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import BooksOrderModal from "../../Books/Order/BooksOrderModal";
import FilledButton from "../../common/Button/FilledButton";
export const initialModalProps = {
    isOpen: false,
    onClose: ()=>{},
    title: "",
    content: ""
};
const Dialog = (param)=>{
    let { isOpen , onClose , title , content , severity , prefix , suffix , ...props } = param;
    return /*#__PURE__*/ _jsx(BooksOrderModal, {
        open: isOpen,
        title: title,
        severity: severity,
        onClose: ()=>onClose(),
        content: content,
        ...props,
        footer: /*#__PURE__*/ _jsxs(ButtonBox, {
            children: [
                prefix && /*#__PURE__*/ _jsx(FilledButton, {
                    type: "text",
                    variant: prefix.variant,
                    onClick: ()=>prefix.handleClick && prefix.handleClick(),
                    children: prefix.label
                }),
                suffix && /*#__PURE__*/ _jsx(FilledButton, {
                    type: "text",
                    variant: suffix.variant,
                    onClick: ()=>suffix.handleClick && suffix.handleClick(),
                    children: suffix.label
                })
            ]
        })
    });
};
const ButtonBox = styled.div.withConfig({
    componentId: "sc-229fa5cb-0"
})(_templateObject());
export default Dialog;
